/** Only idle/error allow another Save & Exit attempt; saved and saving are terminal/busy. */
export function canStartSaveExit(status) {
    return status === 'idle' || status === 'error';
}
export function formatRecipeExpiry(expiresAt) {
    const parsed = Date.parse(expiresAt);
    if (!Number.isFinite(parsed)) {
        return expiresAt;
    }
    return new Date(parsed).toLocaleString();
}
